// extracted by mini-css-extract-plugin
module.exports = {"itemTitle":"CloseAccount_itemTitle__1gjfv","primaryButton":"CloseAccount_primaryButton__3zTRH"};